import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { refSagaActions } from "../../Information/Reference";
import { paymentSagaActions, paymentReducerActions } from "..";
import { Button, Form, Col, Card, Image, Container, Row, Spinner, Modal, ModalBody } from "react-bootstrap";
import { CreditCard, ArrowBarLeft } from "react-bootstrap-icons";
import HCaptcha from '@hcaptcha/react-hcaptcha';
import PhoneInput from "react-phone-input-2";
import * as Yup from "yup";
import { SelectedServiceItemDetails } from "../components/SelectedServiceItemDetails";
import { useSubheader } from "../../../../_metronic/layout";
import styles from "../css/payment.module.css";
import 'react-phone-input-2/lib/style.css';
import { getRefIdByCode } from "../../../../utilities/lookup";
import { postForm } from "../../../../utilities/form";
import { useFormik } from "formik";
import logman from "../../../../utilities/logman";


const BSPPAY_POST_ORDER_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BSPPAY_PROD : process.env.REACT_APP_BSPPAY_TEST;
const BSPCARD_POST_ORDER_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BSPCARD_PROD : process.env.REACT_APP_BSPCARD_TEST;

const windowWidth = window.innerWidth;

let captchaIsValidated = false;

export const PaymentForm = (props) => {

  const subheader = useSubheader();
  const history = useHistory();
  const dispatch = useDispatch();

  const { reference, payment, catalogue } = useSelector(state => state);

  const { allReferences, referenceKinds } = reference;
  const { captchaValidated, orderInfo, validatingCaptcha, processingOrder, callingPaymentEndpoint } = payment;
  const { selectedServiceItem, selectedDept } = catalogue;

  const defaultPaymentRailId = getRefIdByCode(allReferences, 'BSPPAY', 'PAYMENT_RAIL_TYPE');//BSPPay
  const defaultPaymentStatusId = getRefIdByCode(allReferences, '00', 'PAYMENT_STATUS');//Successful

  const initialValue = {
    firstName: "",
    lastName: "",
    titleId: "",
    email: "",
    mobileNumber: "",
    customerIdType: "",
    idNumber: "",
    paymentStatusId: defaultPaymentStatusId, //Successful
    paymentRailTypeId: defaultPaymentRailId, //BSP Pay    
    serviceItemId: selectedServiceItem.id,
  };

  const paymentRailOptions = [
    { id: defaultPaymentRailId, label: 'BSP Pay', logo: '../media/logos/bsppay.png' },
    { id: getRefIdByCode(allReferences, 'CCARD', 'PAYMENT_RAIL_TYPE'), label: 'Visa/Mastercard', logo: '../media/logos/visa_mastercard.jpg' },

  ];

  subheader.setTitle("Service Payment");

  const [titles, setTitles] = useState([]);
  const [idTypes, setIdTypes] = useState([]);
  const [hCAPTCHAValid, sethCAPTCHAValid] = useState(false);
  const [captchaSize, setCaptchaSize] = useState('normal');

  //search form schema definition
  const detailsFormSchema = Yup.object().shape({
    prioritySearch: Yup.object({}),
    firstName: Yup.string()
      .matches(/^[a-zA-Z'\s]{1,20}$/, "*Invalid character input")
      .required("First Name is required"),
    lastName: Yup.string()
      .matches(/^[a-zA-Z'\s]{1,20}$/, "*Invalid character input")
      .required("Last Name is required"),
    mobileNumber: Yup.string().required("Mobile Number is required").matches(/^(675)(70|71|72|73|74|79|80|81|82|83|84|85|86|87|88|89)\d{6}$/, "Please enter a valid Digicel or Vodafone mobile number"),
    email: Yup.string()
      .required("Email is required")
      .email("*Invalid email format"),
    titleId: Yup.string()
      .max(4, "*Invalid"),
    customerIdType: Yup.string()
      .max(4, "*Invalid")
      .required("Customer Type is required"),
    paymentRailTypeId: Yup.string().required("*Select your payment method"),
    idNumber: Yup.string()
      .matches(/^[0-9a-zA-Z#]*$/, "*Only alphanumeric and '#' characters allowed")
      .min(5, "Minimum of 5 characters")
      .max(15, "*Max of 15 characters")
      .required("Id Number is required")
  });

  const checkAndDispatchOrderProcessing = (data) => {

    switch (formik.values.paymentRailTypeId) {
      case getRefIdByCode(allReferences, 'BSPPAY', 'PAYMENT_RAIL_TYPE'):
        dispatch(paymentSagaActions.processBSPPayOrder(data));
        break;
      case getRefIdByCode(allReferences, 'CCARD', 'PAYMENT_RAIL_TYPE'):
        dispatch(paymentSagaActions.processBSPCardOrder(data));
        break;
      default:
        logman.error("Unknown Payment Rail Selected!");
        break;
    }
  }

  const handleSubmitRequest = (custDetails) => {

    let paymentParams = {
      currencyCode: "PGK",
      orderItems: [{
        service_item_id: selectedServiceItem.id,
        service_cat_item_id: selectedServiceItem.service_catalog_item_id,
        quantity: 1
      }],
      customer: {
        first_name: custDetails.firstName,
        last_name: custDetails.lastName,
        mobile_number: custDetails.mobileNumber,
        email: custDetails.email,
        customer_id_type: custDetails.customerIdType,
        id_number: custDetails.idNumber,
        title_id: custDetails.titleId
      }
    };
    checkAndDispatchOrderProcessing(paymentParams);
  };


  const handleCancelRequest = () => {
    let path = "/catalogue-management/region";
    history.push(path);
  };

  const handleBackNavigation = () => {
    history.push({ pathname: "/catalogue-management/service-items" });
  };

  const handleHCAPTCHA = (token, ekey) => {

    let params = {
      stringOne: "0xC7F132605D0a353A52bf778aD96D0436853ff3A2",
      stringTwo: token
    };

    dispatch(paymentSagaActions.verifyHCAPTCHA(params));
    sethCAPTCHAValid(true);

    const getHCaptcha = () => {
      if (!captchaIsValidated) {
        dispatch(paymentSagaActions.verifyHCAPTCHA(params));
      } else {
        clearInterval(timerId); //stop the timer
      }
    };

    let timerId;

    if (!captchaIsValidated) {
      timerId = setInterval(() => getHCaptcha(), 7000);

      setTimeout(() => { clearInterval(timerId); }, 120000); //always clear the interval after 2 minutes, regardless
    }

  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: detailsFormSchema,
    onSubmit: (values, { setSubmitting }) => { //onSubmit 2nd Param is formikBag, inside which setSubmitting is a part of
      if (captchaValidated) {
        const custDetails = {
          firstName: values.firstName.trim(),
          lastName: values.lastName.trim(),
          mobileNumber: values.mobileNumber.trim(),
          email: values.email.toLowerCase(),
          titleId: values.titleId || null,
          customerIdType: values.customerIdType,
          idNumber: values.idNumber,
          paymentRailTypeId: values.paymentRailTypeId
        };

        handleSubmitRequest(custDetails); // sync call
      }

      // Always stop submitting after processing, even if captcha fails
      setSubmitting(false);
    }
  });


  useEffect(() => {
    if (Object.keys(selectedServiceItem).length === 0) {
      history.push("/catalogue-management");
    }
  }, [selectedServiceItem, history]);

  useEffect(() => {
    captchaIsValidated = captchaValidated;
    if (referenceKinds.length > 1) {
      let titleList = allReferences.filter((ref) => (ref.kindCode === 'TITLE'));
      let idTypeList = allReferences.filter((ref) => (ref.kindCode === 'CUSTOMER_ID_TYPE'));
      setTitles(titleList);
      setIdTypes(idTypeList);
    }
  }, [referenceKinds, allReferences, captchaValidated]);

  useEffect(() => {
    //setting the captcha component size
    if (windowWidth < 400) {
      setCaptchaSize('compact');
    } else {
      setCaptchaSize('normal');
    }
    dispatch(paymentReducerActions.resetState());
    dispatch(refSagaActions.fetchAllReferences());
    dispatch(refSagaActions.fetchReferenceKinds());

  }, [dispatch]);


  const bspPayIPGWRedirect = useCallback(() => {

    if (orderInfo?.encryptedPayload && orderInfo?.encryptedPayload?.length > 0 && Object.keys(orderInfo).length > 0) {

      //set bsppay ipgw form data for WOOCOMMERCE ORDER API call
      let formParamObj = {
        order_id: orderInfo.orderId,
        merchant_key: orderInfo.merchantKey,
        URL: orderInfo.callbackUrl,
        URLC: "en",
        order_details: orderInfo.encryptedPayload
      }

      postForm(BSPPAY_POST_ORDER_URL, formParamObj);

    }
  },[orderInfo]);

  const bspCardIPGWRedirect = useCallback(() => {

    if (orderInfo && Object.keys(orderInfo).length > 0) {

      //set bspcard doku ipgw form data for RECEIVE API call
      let formParamObj = {
        MALLID: orderInfo?.mallid,
        CHAINMERCHANT: orderInfo?.chainMerchant ?? "NA",
        AMOUNT: orderInfo?.purchaseAmount,
        PURCHASEAMOUNT: orderInfo?.purchaseAmount,
        TRANSIDMERCHANT: orderInfo?.transIdMerchant,
        PAYMENTTYPE: orderInfo?.paymentType ?? "SALE",
        WORDS: orderInfo?.words,
        REQUESTDATETIME: orderInfo?.requestDateTime,
        CURRENCY: orderInfo?.currency,
        PURCHASECURRENCY: orderInfo?.purchaseCurrency,
        SESSIONID: orderInfo?.sessionId?.slice(0, 48), // ensure max 48 chars
        NAME: orderInfo?.name || "-",
        EMAIL: orderInfo?.email || "-",
        ADDITIONALDATA: JSON.stringify(orderInfo?.additionalData ?? {}),
        BASKET: orderInfo?.basket ?? "Item,0.00,1,0.00",
        PAYMENTCHANNEL: orderInfo?.paymentChannel ?? "15"
      };

      postForm(BSPCARD_POST_ORDER_URL, formParamObj);
    }

  },[orderInfo]);




  //THIS USEEFFECT SHOULD ONLY EXECUTE THE FUNCTIONS IN THE CALLSTACK AFTER ORDER IS CREATED AND RETURNED 
  // WHICH IN TURN UPDATES STATE TO CAUSE THIS USEEFFECT TO FIRE!
  useEffect(() => {

    const checkAndRedirectToSelectedPaymentRailIPGW = () => {
      if (!orderInfo?.paymentRailTypeId) {
        return;
      }
      switch (orderInfo?.paymentRailTypeId) {
        case getRefIdByCode(allReferences, 'BSPPAY', 'PAYMENT_RAIL_TYPE'):
          bspPayIPGWRedirect();
          break;
        case getRefIdByCode(allReferences, 'CCARD', 'PAYMENT_RAIL_TYPE'):
          bspCardIPGWRedirect();
          break;
        default:
          logman.error("Unknown Payment Rail Selected!");
          break;
      }
    };

    checkAndRedirectToSelectedPaymentRailIPGW();

  }, [allReferences, bspCardIPGWRedirect, bspPayIPGWRedirect, orderInfo.paymentRailTypeId]);



  return (
    <Container fluid>
      <Row>
        <Col lg={9} md={6} sm={12} className="mb-5">
          <Card>
            <Card.Header>
              <Row>
                <Col lg={10} md={12} sm={12}>
                  <h4 className="d-flex align-items-center justify-content-left">
                    <CreditCard size={48} className="mr-3" />
                    <span>Customer and Service Payment Details</span>
                  </h4>
                  <span className="text-muted"> Enter your details to proceed to payment </span>
                </Col>
                <Col lg={2} md={12} sm={12}>
                  <Button onClick={handleBackNavigation} style={{ float: "right" }} variant="secondary">
                    <ArrowBarLeft size={18} /> {" "} BACK
                  </Button>
                </Col>
              </Row>

            </Card.Header>
            <Card.Body className="pt-0">
              <Form onSubmit={formik.handleSubmit}>
                <fieldset className="border border-secondary p-5 mb-5">
                  <legend className="w-auto px-3 py-2 ml-3 text-left">Customer Details </legend>
                  <Form.Row>
                    <Col lg={2} md={12} sm={12}>
                      <Form.Group controlId="titleId">
                        <Form.Label>Title:</Form.Label>
                        <Form.Control
                          as="select"
                          name="titleId"
                          value={formik.values.titleId}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          <option value="">-- Select --</option>

                          {titles.map((t, index) => (
                            <option key={index} value={t.id}>
                              {t.description}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </Col>

                    <Col lg={5} md={12} sm={12}>
                      <Form.Group controlId="firstName" className="required">
                        <Form.Label>First Name:</Form.Label>
                        <Form.Control
                          name="firstName"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.firstName}
                          isInvalid={formik.errors.firstName && formik.touched.firstName}
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.firstName}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={5} md={12} sm={12}>
                      <Form.Group controlId="lastName" className="required">
                        <Form.Label>Last Name:</Form.Label>
                        <Form.Control
                          name="lastName"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.lastName}
                          isInvalid={formik.errors.lastName && formik.touched.lastName}
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.lastName}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Form.Row>
                  <Form.Row>
                    <Col lg={3} md={12} sm={12}>
                      <Form.Group controlId="mobileNumber" className="required">
                        <Form.Label>Mobile Number:</Form.Label>
                        <PhoneInput
                          name="mobileNumber"
                          country={'pg'}
                          value={formik.values.mobileNumber}
                          inputStyle={{ width: '100%', height: 'calc(1.5em + 1.3rem + 2px)', borderColor: '#E4E6EF', borderRadius: '0.42rem' }}
                          onBlur={() => {
                            formik.setFieldTouched('mobileNumber', true);
                          }}
                          onChange={(value, countryData, event, formattedValue) => {
                            formik.setFieldValue('mobileNumber', value);
                          }}
                          countryCodeEditable={false}
                          disableDropdown={true}

                        />

                        {formik.touched.mobileNumber && formik.errors.mobileNumber && (
                          <small style={{ color: "red" }}>{formik.errors.mobileNumber}</small>
                        )}

                      </Form.Group>
                    </Col>
                    <Col lg={5} md={12} sm={12}>
                      <Form.Group controlId="email">
                        <Form.Label>Email:</Form.Label>
                        <Form.Control
                          name="email"
                          value={formik.values.email}
                          isInvalid={formik.errors.email && formik.touched.email}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.email}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={2} md={12} sm={12}>
                      <Form.Group controlId="idType" className="required">
                        <Form.Label>ID Type:</Form.Label>
                        <Form.Control
                          as="select"
                          name="customerIdType"
                          value={formik.values.customerIdType}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          <option value="">-- Select --</option>

                          {idTypes.map((id, index) => (
                            <option key={index} value={id.id}>
                              {id.description}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.customerIdType}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={2} md={12} sm={12}>
                      <Form.Group controlId="idNumber" className="required">
                        <Form.Label>ID Number:</Form.Label>
                        <Form.Control
                          name="idNumber"
                          value={formik.values.idNumber}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder={!formik.values.customerIdType ? "Select ID type" : ""}
                          disabled={!formik.values.customerIdType}
                          isInvalid={formik.errors.idNumber && formik.touched.idNumber}
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.idNumber}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Form.Row>
                </fieldset>

                <fieldset className="border border-secondary p-5 mb-5">
                  <legend className="w-auto px-3 py-2 ml-3 text-left"> Payment Method </legend>
                  <Form.Group controlId="paymentRailTypeId" className="mb-0">
                    <Form.Row>
                    {paymentRailOptions.map((option, index) => {
                      
                      if (!option?.id) {
                        console.warn("Invalid option with null/undefined id:", option);
                        return null; // prevent rendering invalid options
                      }

                      return (
                        <Col key={option.id} xs={12} sm={6} md={4} lg={3}>
                          <Form.Check
                            type="radio"
                            name="paymentRailTypeId"
                            id={`payment-${option.id}`}
                            value={option.id}
                            checked={formik.values?.paymentRailTypeId?.toString() === option?.id?.toString()}
                            onChange={() => formik.setFieldValue("paymentRailTypeId", option.id)}
                            className={styles.paymentTypeRadioCheck}
                            label={
                              <div className="d-flex flex-column align-items-center text-center mb-10 lg:mb-3">
                                <span className="mb-2">{option.label}</span>
                                <Image src={option.logo} style={{ width: "120px", height: "auto" }} />
                              </div>
                            }
                          />
                        </Col>
                      );
                    })}
                    </Form.Row>

                    {formik.touched.paymentRailTypeId && formik.errors.paymentRailTypeId && (
                      <div className="text-danger mt-1">{formik.errors.paymentRailTypeId}</div>
                    )}
                  </Form.Group>

                </fieldset>

                <Form.Row>
                  <Col lg={3} md={12} sm={12}>
                    <Form.Group controlId="hCAPTCHA" style={{ width: 'fit-content' }}>
                      <HCaptcha
                        sitekey="510df4cb-82f7-4030-961e-793fa8bb0636"
                        onVerify={handleHCAPTCHA}
                        onExpire={() => { sethCAPTCHAValid(false) }}
                        size={captchaSize}
                      />
                    </Form.Group>
                  </Col>
                </Form.Row>
                <Button className="mr-4 mb-lg-1 mb-3" type="submit" variant="primary" disabled={formik.isSubmitting || !(hCAPTCHAValid && captchaValidated && !validatingCaptcha && !processingOrder)}>
                  {processingOrder && <Spinner animation="border" size="sm" />} {" "}
                  {
                    validatingCaptcha ? "Verifying CAPTCHA..." : "Proceed to Payment"
                  }
                </Button>
                <Button onClick={() => { handleCancelRequest(); formik.handleReset(); }} variant="secondary">
                  Cancel
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={3} md={6} sm={12}>
          <SelectedServiceItemDetails item={selectedServiceItem} deptLogo={selectedDept.logo_image} />
        </Col>
      </Row>
      <Modal show={callingPaymentEndpoint} aria-labelledby="contained-modal-title-vcenter" centered >
        <ModalBody className="d-flex align-items-center">
          <Spinner animation="grow" size="lg" variant="info" /> <span className="pl-5"> Processing your payment details... </span>
        </ModalBody>
      </Modal>
    </Container>
  );
};
